import { buildDiagnosisResult } from './builders';
import type { DiagnosisResultContent } from './types';

/** SALZ（S即興・Aアクティブ・L冒険グルメ・Z癒し） */
const salzContent: DiagnosisResultContent = {
  code: 'SALZ',
  name: '風まかせビーチ族',
  catchphrase: '「なんとかなるっしょ」が口癖。究極のリラックス旅行者',
  rarity: 4,
  style:
    '「自由に動いて、最後は癒される」が信条の即興派。計画に縛られず、その日の気分でアクティビティもグルメも選ぶ。よく動くがゴールは「リラックス」。海辺やリゾートで開放感に浸りながら、現地の食や体験も気ままに楽しむ。アクティブさと脱力を行き来できる、切り替え上手な自由人タイプ。',
  strengths: [
    { lead: '切り替えが上手い', text: 'よく動いた後にしっかり癒され、疲れを翌日に残さない。' },
    { lead: '開放感を楽しめる', text: '計画に縛られず、その場の気分で最高の過ごし方を選べる。' },
    { lead: '順応力が高い', text: '天候や気分の変化に合わせて柔軟に予定を変えられる。' },
  ],
  weaknesses: [
    { lead: '予定が読めない', text: '気分次第で動くため、同行者と足並みが揃いにくい。' },
    { lead: 'だらけやすい', text: '癒し優先に傾くと、せっかくの体験機会を逃すことも。' },
    { lead: '段取り不足', text: '人気のビーチアクティビティは予約で埋まりがち。' },
  ],
  aaru: [
    { icon: 'coffee', text: 'ビーチで昼寝が至福' },
    { icon: 'msg', text: '「今日は海でいっか」が口癖' },
    { icon: 'camera', text: '夕日の写真がフォルダに大量' },
    { icon: 'utensils', text: '海辺の店に気まぐれ入店' },
  ],
  manual: {
    good: '気分の変化に寛容に／脱力タイムを一緒に楽しむ',
    ng: '「分刻みで動こう」と急かす',
    tips: 'マリンアクティビティだけ前日予約すると満足度UP',
  },
  compatibility: {
    good: 'SALE（即興仲間）／SACZ（脱力系）',
    conflict: 'PACE（詰め込み計画）／PRLE（探究型）',
    tips: '集合は「ゆるめ」に設定すると衝突しない',
  },
  destinations: {
    domestic: '沖縄（ビーチと開放感）／宮古島（海でとことん癒し）',
    overseas: 'バリ（リゾートと自由）／セブ（海遊びと脱力）',
  },
};

export const salzDiagnosisResult = buildDiagnosisResult(salzContent);
